
export default {
  async asyncData({ $getContent }) {
    return {
      commands: await $getContent('commands'),
    }
  },
  data() {
    return {
      search: '',
      category: 'All',
      prefix: this.$route.query.prefix || '=',
    }
  },
  head: {
    title: 'Commands',
  },
  computed: {
    categories() {
      return [
        'All',
        ...this.commands.filter(element => !element.description).map(element => element.name),
      ]
    },
    activeCommands() {
      return this.commands.filter(element => {
        return (
          element.description &&
          (this.category === 'All' || this.category === this.getParent(element.name)) &&
          (element.name.includes(this.search) ||
            (element.alias && element.alias.includes(this.search)))
        )
      })
    },
  },
  methods: {
    getParent(name) {
      return this.commands
        .slice(
          0,
          this.commands.findIndex(element => element.name === name)
        )
        .reverse()
        .find(element => !element.description).name
    },
    updateCategory(tabs, index) {
      this.category = tabs[index].title
    },
  },
}
